import React from 'react'
import { TTimelineItemStatus } from '../../type'
import { Wrapper, Item } from './styles'

interface Props {
  'data-qa'?: string
  items: IItem[]
}

const Timeline: React.FC<Props> = (props: Props): JSX.Element => {
  return (
    <Wrapper data-qa={props['data-qa']}>
      {props.items.map((item, key) => {
        return (
          <Item
            status={item.status}
            key={key}
            data-qa={props['data-qa'] && `${props['data-qa']}-item-${key}`}
          >
            {item.label}
          </Item>
        )
      })}
    </Wrapper>
  )
}

export default Timeline

export interface IItem {
  label: string
  status: TTimelineItemStatus
}
